export default __webpack_public_path__ + "static/media/slider2-4.159bdf6e.jpg";